import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'cp-progresschart',
    templateUrl: './cp-progresschart.component.html',
    styleUrls: ['./cp-progresschart.component.css'],
    standalone: false
})
export class CpProgresschartComponent implements OnInit {
  @Input() percent: number;

  ngOnInit(): void {
    this.percent = 0;
  }

}
